var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.description.length)?_c('div',{staticClass:"time-zone-form-label"},[_c('span',[_vm._v(_vm._s(_vm.description))]),(_vm.changeable)?_c('b-link',{staticClass:"ml-1",on:{"click":function($event){$event.preventDefault();return _vm.changeRequested.apply(null, arguments)}}},[_vm._v("(change)")]):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }